import type { CategoryCatalogModel, StrapiResponseModel } from '@/interfaces/model';
import type { CategoryCatalog, StrapiListResponse } from '@/interfaces/strapi';

export const catalogCategoryMapper = (c: CategoryCatalogModel): CategoryCatalog => ({
	id: c.documentId,
	name: c.name,
	slug: c.slug,
});

export const catalogCategoriesListMapper = (
	res: StrapiResponseModel<CategoryCatalogModel>,
): StrapiListResponse<CategoryCatalog> => {
	const list = (res.data ?? []).map(catalogCategoryMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
